import React, {Component} from 'react';
// import {
//   Button,
//   Icon,
// }                         from 'semantic-ui-react';
// import PropTypes          from 'prop-types';
import BodyClassName      from 'react-body-classname';
import {Icon}             from 'semantic-ui-react';

import MainMenu           from '../../organisms/MainMenu';
import MainHome           from '../../organisms/MainHome';
import MainLoading        from '../../organisms/MainLoading';
import MainLogin          from '../../organisms/MainLogin';

// Moledule
import SgrModal           from '../../molecules/SgrModal';

// Styles
import                    './HomePage.scss';

import img1               from '../../images/choir.jpg';
import img2               from '../../images/stage.jpg';
import img3               from '../../images/partitions.jpeg';
import img4               from '../../images/contact_me.jpeg';
import img5               from '../../images/OpenMic.jpg';
import img6               from '../../images/musicawareness.jpg';
import img7               from '../../images/lesson.jpg';
import img8               from '../../images/musictherapybg.jpg';

const propTypes = {};
const defaultProps = {};

class HomePage extends Component {

  constructor(props) {
    super(props);

    this.state = {openMenu: false};

    this.handleOpenMenu = this.handleOpenMenu.bind(this);
    this.setModalRef = this.setModalRef.bind(this);
    this.handleCloseLogin = this.handleCloseLogin.bind(this);

    this.modalref = null;
  }

  setModalRef(ref = {}) {
    if (ref) {
      this.modalref = ref;
      ref.open();
    }
  }

  handleOpenMenu() {
    this.setState({openMenu: !this.state.openMenu});
  }

  handleCloseLogin() {
    this.modalref.close();
  }

  render() {
    const {openMenu} = this.state;
    openMenu;

    return (
      <BodyClassName className='sgr-main'>
        <div className='sgr-homepage'>
          <MainLoading />
          <MainMenu />
          <MainHome />
          <div className='social-link'>
            <a href='https://www.youtube.com/channel/UCX7jL9svyKfu3kdjOeu01Ig'>
              <Icon
                name='youtube'
              />
              {'Youtube'}
            </a>
            <a href='https://www.facebook.com/gaelleboudiersinger/'>
              <Icon
                name='facebook'
              />
              {'Facebook'}
            </a>
          </div>
          <SgrModal
            content={<MainLogin onClose={this.handleCloseLogin} />}
            header='Login'
            ref={this.setModalRef}
          />
          <div id='preload'>
            <img src={img1} />
            <img src={img2} />
            <img src={img3} />
            <img src={img4} />
            <img src={img5} />
            <img src={img6} />
            <img src={img7} />
            <img src={img8} />
          </div>
        </div>
      </BodyClassName>
    );
  }

}

HomePage.propTypes = propTypes;
HomePage.defaultProps = defaultProps;

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/home/HomePage.js